import Api from "../../api/index";
import idb from "../../idb/users";

import { Ability } from "@casl/ability";
export const ability = new Ability();

export const User = {
  namespaced: true,
  state: {
    allUsers: null,
    oneUser: null,
    rules: null,

    token_type: null,
    token_access_token: null,
    token_client: null,
    toekn_uid: null,
    toekn_expiry: null,

    updateUserWasGood: null,
    updateUserMessage: null,
  },
  getters: {
    getUserCompanyName: state => {
      return state.oneUser.company? state.oneUser.company.data.attributes.name : null;
    },
    getUserCompanyId: state => {
      return state.oneUser.company? state.oneUser.company.data.attributes.id : null;
    },
    getUserCompanyLogo: state => {
      return state.oneUser.company? state.oneUser.company.data.attributes.company_logo : null;
    },
  },
  mutations: {
    setAllUsers(state, all) {
      state.allUsers = all.data.map((obj) => obj.attributes);
    },
    setCurrentUser(state, data) {
      state.oneUser = data;
      let all_perm = {
        cans: [],
        cannots: []
      }
      let list = []

      // console.log({data})

      data.roles.sort((a,b)=> a.id < b.id? -1 : a.id > b.id? 1 : 0).forEach(role => {
        // console.log({role: role.name})
        let cans = [...(role.permissions.can || [])]
        let cannots = [...(role.permissions.cannot || [])]
        if (cannots.length){
          cannots = cannots.map(cannot=> {return {...cannot, inverted: true}})
        }

        list = [...list, ...cans, ...cannots]
      });

      state.rules = data.roles[0].permissions;

      // let cans = [...state.rules.can]
      // let cannots = []
      // if (state.rules.cannot){
      //   cannots = [...state.rules.cannot.map(cannot=> {return {...cannot, inverted: true}})]
      // }
      // let list = [...all_perm.cans, ...all_perm.cannots,...all_perm.cans]
      ability.update(list);
      // console.log({ability});
      // ability.update(state.rules.cannot.map(cannot=> {return {...cannot, inverted: true}}));
    },
    logout(state) {
      state.oneUser = null;
      state.rules = null;
      ability.update([]);
    },
    setTokenData(state, token) {
      state.token_type = token ? token.split(";")[0] : null;
      state.token_access_token = token ? token.split(";")[1] : null;
      state.token_client = token ? token.split(";")[2] : null;
      state.toekn_uid = token ? token.split(";")[3] : null;
      state.toekn_expiry = token ? token.split(";")[4] : null;
    },

    setProfile(state, User) {
      state.oneUser = User.data.attributes; // User.data
    },

    updateResponse(state, { was_good, msg }) {
      state.updateUserWasGood = was_good;
      state.updateUserMessage = msg;
      setTimeout(() => {
        state.updateUserWasGood = null;
      }, 100);
    },
  },

  actions: {
    preloadUsersToIdb(){
      Api.User.indexEmployee({preload: true}).then((response) => response.data).then((allUsers) => {
        idb.store_users(allUsers.data.map((obj) => obj.attributes))
      })
      .catch(function(error) {
        console.log(error);
      });
    },
    
    index(context) {
      Api.User.index()
        .then((response) => response.data)
        .then((allUsers) => {
          context.commit("setAllUsers", allUsers);
        })
        .catch(function(error) {
          // auto-comment// console.log(error);
        });
    },
    update(context, user) {
      Api.User.update(user)
        .then((response) => response.data)
        .then((allUsers) => {
          // context.commit("setAllUsers", allUsers);
          context.commit("updateResponse", { msg: "", was_good: true });
        })
        .catch(function(error) {
          // auto-comment// console.log(error);
          context.commit("updateResponse", {
            msg: error.response.data.errors[0],
            was_good: false,
          });
        });
    },
    showOneUser(context, id) {
      // context.commit('getOneUser', id)
    },
    setUser(context, data) {
      context.commit("setCurrentUser", data);
    },
    setProfile(context) {
      Api.User.profile()
        .then((response) => response.data)
        .then((user) => {
          context.commit("setProfile", user);
        })
        .catch(function(error) {
          console.log({ error_in_profile: error });
        });
    },
  },
};

// export default User;
